module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-EB_1.d9dcfaaf.jpg";